<template>
	<div class="flex tr main">
		<div class="flex w-full space-x-4">
			<BaseInput
				:label="$t('manufacturer')"
				:sublabel="$t('according_identifier_brackets')"
				:disabled="true"
				v-model="manufacturer"
				class="w-1/4"
				:title="manufacturer"
			/>
			<BaseInput
				:label="$t('wmi')"
				ref="BaseInput.unchecked_wmi.0"
				:placeholder="$t('wmi')"
				@input="updateManufacturer"
				v-model="model.wmi"
				class="w-24"
				mask="BBB"
				:required="true"
				:error-message="$t('required_value')"
			/>
			<BaseInput
				:label="$t('vds')"
				ref="BaseInput.unchecked_vds.0"
				:placeholder="$t('vds')"
				v-model="model.vds"
				class="w-24"
				mask="BBBBBB"
				:required="true"
				:error-message="$t('required_value')"
			/>
			<BaseInput
				:label="$t('name')"
				ref="BaseInput.unchecked_name.0"
				:placeholder="$t('name')"
				v-model="model.name"
				class="flex-grow"
				mask="CXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
				:required="true"
				:error-message="$t('required_value')"
			/>
			<div class="ml-4 flex items-center justify-center h-12 w-12"></div>
		</div>
	</div>
</template>
<script>
import BaseInput from '@/components/forms/inputs/BaseInput';
import VehicleModelRepository from '@/api/repositories/VehicleModelRepository';
import Validate from '@/mixins/Validate';
import VehicleManufacturerRepository from '@/api/repositories/VehicleManufacturerRepository';

export default {
	name: 'VehicleModel',
	components: { BaseInput },
	mixins: [Validate],
	data() {
		return {
			model: {},
			manufacturer: null,
		};
	},
	computed: {
		isNew() {
			return this.$route.name === 'vehicles.model.new';
		},
	},
	mounted() {
		if (!this.isNew) {
			VehicleModelRepository.show(this.$route.params.id).then(response => {
				this.model = response.data.data;
				this.manufacturer = this.model.manufacturer.name;
			});
		}
	},
	methods: {
		save() {
			if (this.validate()) {
				return this.updateInsert();
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
		updateManufacturer(wmi) {
			if (wmi.length < 3) return;
			VehicleManufacturerRepository.index({ wmi }).then(response => {
				this.manufacturer = response.data.data[0]?.name ?? null;
			});
		},
		updateInsert() {
			if (this.isNew) {
				this.model.checked = true;
				return VehicleModelRepository.store(this.model).then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.model = response.data.data;
					this.$store.commit('popModalHistory');
					this.$router.replace({ name: 'vehicles.model.id', params: { id: this.model.id } });
					return this.$swal(this.$t('general.success').toString(), this.$t('model_stored').toString(), 'success').then(() =>
						this.$router.push({ name: 'vehicles.overview' }),
					);
				});
			} else {
				this.model.is_checked = true;
				return VehicleModelRepository.update(this.model.id, this.model).then(response => {
					this.$store.commit('setConfirmLeaving', false);
					return this.$swal(this.$t('general.success').toString(), this.$t('model_saved').toString(), 'success').then(() =>
						this.$router.push({ name: 'vehicles.overview' }),
					);
				});
			}
		},
	},
};
</script>
